import { Box, Button, CloseButton, Flex, Stack, Text } from '@mantine/core';
import { FieldValues, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControlInput, NumberInputControl } from '@/core/components';

import { ProjectStatusSelectControl } from './ProjectStatusSelectControl';

export interface StatusYearListControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;

  description?: string;
  isDisabled?: boolean;
}

const defaultStatusYearList = {
  year: new Date().getFullYear(),
};

export function StatusYearListControl<T extends FieldValues>(props: StatusYearListControlProps<T>) {
  const { label, description, name, isSubmitting, isDisabled, control } = props;
  /* @ts-expect-error fix later */
  const { fields, append, remove } = useFieldArray({ name, keyName: 'uuid', control });
  const { t } = useTranslation();

  return (
    <Box>
      <Flex justify="space-between">
        <Box>
          <Text
            fw="500"
            size="xl"
          >
            {label}
          </Text>
          {description && <Text c="dimmed">{description}</Text>}
        </Box>
        <Button
          disabled={isDisabled}
          // @ts-expect-error fix later
          onClick={() => append(defaultStatusYearList)}
        >
          {t('button.add')}
        </Button>
      </Flex>
      <Stack gap="xl">
        {fields.length === 0 && (
          <Text
            size="xs"
            c="dimmed"
            fs="italic"
          >
            {t('projects.form.fields.emptyStatusYearList')}
          </Text>
        )}
        {fields.map((field, index) => (
          <Flex
            align="center"
            justify="center"
            gap="4px"
            key={field.uuid}
          >
            <Text
              mr="8px"
              mt="25px"
              size="sm"
            >
              #{index + 1}
            </Text>
            {/* @ts-expect-error fix later */}
            <NumberInputControl
              label={t('projects.form.fields.year')}
              control={control}
              name={`${name}.${index}.year`}
              isSubmitting={isSubmitting}
              isDisabled={isDisabled}
              withAsterisk
            />
            {/* @ts-expect-error fix later */}
            <ProjectStatusSelectControl
              label={t('projects.form.fields.status')}
              control={control}
              name={`${name}.${index}.status`}
              isSubmitting={isSubmitting}
              isDisabled={isDisabled}
              withAsterisk
            />
            <CloseButton
              mt="25px"
              onClick={() => remove(index)}
              c="red"
            />
          </Flex>
        ))}
      </Stack>
    </Box>
  );
}
